import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {TwoRowItemCard} from '../../two-row-item/two-row-item-card';

import type {CardData} from './option-card-builder-field';

type Props<T> = {
    meta: FieldProps['meta'];
    input: FieldProps['input'];
    cardCreator: (arg1: {
        meta: FieldProps['meta'];
        input: FieldProps['input'];
        onRemove: () => any;
    }) => any;
    getCardData: (arg1: T) => CardData;
    onRemove: () => any;
};

export function OptionCardField<T>(props: Props<T>) {
    if (!props.input.value) {
        const OptionCardCreator = props.cardCreator;

        return (
            <OptionCardCreator meta={props.meta} input={props.input} onRemove={props.onRemove} />
        );
    }

    const cardData = props.getCardData(props.input.value);

    return (
        <TwoRowItemCard
            topRow={cardData.topRow}
            bottomRow={cardData.bottomRow}
            onRemove={props.onRemove}
        />
    );
}
